import request from '../utils/request';

export function saveProduct(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/product',
            method: 'POST',
            data
        })
    }

    return request({
        url: '/admin/product/'+id,
        method: 'PUT',
        data
    })
}


export function getProductList(param) {
    return request({
        url: '/admin/search-product',
        method: 'GET',
        params: param
    })
}

export function getProduct(id) {
    return request({
        url: '/admin/product/' + id,
        method: 'GET'
    })
}

export function setProductIsValidate(id, isvalidate) {
    return request({
        url: '/admin/product/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}

export function getAllCategory() {
    return request({
        url: '/admin/category-option',
        method: 'GET'
    })
}

export function setProductSort(id, sort) {
    return request({
        url: '/admin/product/'+id+'/sort/'+sort,
        method: 'PUT'
    })
}

export function deleteProduct(id) {
    return request({
        url: '/admin/product/'+id,
        method: 'Delete'
    })
}

